import React from 'react';
import {
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem
} from 'reactstrap';

class PipelineDropdown extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			dropdownOpen: false,
		};
	}

	toggleSelect = () => {
		if (!this.props.loading) {
			this.setState({dropdownOpen: !this.state.dropdownOpen})
		}
	}

	onClick = (pipeline) => {
		this.props.updateFilters(pipeline);
	}

	render() {
		const {dropdownOpen} = this.state;
		return (
			<Dropdown isOpen={dropdownOpen} toggle={() =>this.toggleSelect()}>
				<DropdownToggle caret>
					{this.props.loading ? "Loading" : this.state.selected ? this.state.selected : "Select a Pipeline" }
				</DropdownToggle>
				<DropdownMenu>
					<DropdownItem header>Pipeline Filter</DropdownItem>
					{this.props.pipelines && this.props.pipelines.map(p => {
						return (
							<DropdownItem key={p.ID} onClick={() => this.onClick(p)}>
								{p.Name}
							</DropdownItem>
						);
					})}
				</DropdownMenu>
			</Dropdown>
		);
	}
}

export default PipelineDropdown;
